import axios from "axios";
import { Entity } from "../../types/model/entity/Entity/Entity";
import { SessionStore } from "../../types/store";
import { newAbortSignal } from "../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/entities`;

export const getEntities = async (
  writeAccessOnly?: boolean,
): Promise<Entity[]> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  return await axios
    .get<Entity[]>(BASE_URL, {
      headers: {
        "content-type": "application/json",
        "x-access-token": session?.accessToken,
      },
      params: {
        writeAccessOnly,
      },
      timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
      signal:
        AbortSignal.timeout === undefined
          ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
          : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
    })
    .then((response) => response.data);
};
